import client from './client';
import type { ProductionResult, ProduceVariantRequest, Product } from '@/types/api';

export const productionApi = {
  getCatalog: async (): Promise<Product[]> => {
    const response = await client.get<Product[]>('/production/catalog');
    return response.data;
  },

  produceVariant: async (data: ProduceVariantRequest): Promise<ProductionResult> => {
    const response = await client.post<ProductionResult>('/production/produce', data);
    return response.data;
  },

  previewProduction: async (variantId: string, quantity: number = 1): Promise<ProductionResult> => {
    const response = await client.get<ProductionResult>(`/production/preview/${variantId}`, {
      params: { quantity }
    });
    return response.data;
  },

  getUnitsMakeable: async (variantId: string): Promise<number> => {
    const response = await client.get<number>(`/production/units-makeable/${variantId}`);
    return response.data;
  },
};
